import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.83333 4.16667H8.33333V15.8333H5.83333V4.16667Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.6667 4.16667H14.1667V15.8333H11.6667V4.16667Z",
		fill: "currentColor"
	})]
});
export default SvgPause;
